import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { defaultTo, path } from 'ramda';

import { apiUpdateExperience, apiGetExperience } from '../../../../api/experience';

import Experience from '../../CertificationsAndTraining/Experience/Experience';
import ApproveExperienceModal from '../../../../components/Modal/ApproveExperienceModal';
import RejectExperienceModal from '../../../../components/Modal/RejectExperienceModal';

class Review extends Component {
  static propTypes = {
    fellowshipServiceTypes: PropTypes.array,
  };

  state = {
    experience: null,
    certifications: [],
    loaded: false,
    showApproveModal: false,
    showRejectModal: false,
  };

  componentDidMount() {
    const { match } = this.props;
    const selectedExperienceId = match.params.id;

    apiGetExperience(selectedExperienceId).then((resp) => this.setState({ experience: resp.data, loaded: true }));
  }

  render() {
    if (!this.state.loaded) return <noscript />;
    const { fellowshipServiceTypes } = this.props;
    const { experience, showApproveModal, showRejectModal } = this.state;

    return (
      <Fragment>
        <Experience
          admin
          registrations={defaultTo([], path(['registration', 'user', 'latestRegistrations'], experience))}
          fellowshipServiceTypes={fellowshipServiceTypes}
          experience={experience}
          submit={apiUpdateExperience}
          finish={(resp) => this.setState({ experience: resp.data })}
          approve={() => this.setState({ showApproveModal: true })}
          reject={() => this.setState({ showRejectModal: true })}
        />
        <ApproveExperienceModal
          show={showApproveModal}
          onHide={(newExperience) =>
            this.setState({ showApproveModal: false, experience: defaultTo(experience, newExperience) })
          }
          experience={experience}
        />
        <RejectExperienceModal
          show={showRejectModal}
          onHide={(newExperience) =>
            this.setState({ showRejectModal: false, experience: defaultTo(experience, newExperience) })
          }
          experience={experience}
        />
      </Fragment>
    );
  }
}

export default withRouter(Review);
